import {useEffect} from "react";
import {router, usePage} from "@inertiajs/react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {useAllStore} from "@/Stores/useAllStore";
import {useSearchStore} from "@/Stores/Site/Search";
import {selectGetSearchData} from "@/Stores/Site/Search/Selectors";

export default function usePressPopstateButton() {
    const {basketStore, catalogStore} = useStoreMobx();
    const {url} = usePage();

    const popstateButton = useAllStore((state) => state.popstateButton);
    const setPopstateButton = useAllStore((state) => state.setPopstateButton);
    const searchStoreGetSearchData = useSearchStore(selectGetSearchData);

    useEffect(() => {
        if (popstateButton) {
            if (url.includes('basket')) {
                basketStore.getBasket(true);
            } else if (url.includes('go-to-checkout')) {
                basketStore.getBasketGoToCheckout(true);
            } else if (url.includes('search')) {
                searchStoreGetSearchData(true);
            }
            // else if (url.includes('catalog') && !url.includes('product')) {
            //     console.log('catalogStore.page', catalogStore.page);
            //     console.log('catalogStore.activePage', catalogStore.activePage);
            //     // catalogStore.getCatalogData(true);
            // }
            else {
                // По кнопкам назад вперед всегда запрашиваем данные с сервера
                router.reload();
                // Для блога и новостей нужно сделать, чтобы выбранная категория и выбранная страница не скидывалась!!!
            }
        }

        setPopstateButton();
    }, []);
}
